import React, { useState } from "react";
import { useField } from "formik";
import { FaEye } from "react-icons/fa";
import { LuEyeClosed } from "react-icons/lu";
import { IoPersonOutline } from "react-icons/io5";
import { MdOutlineLock } from "react-icons/md";

const FromInput = ({ label, icon, ...props }) => {
  const [field, meta] = useField(props);
  const errorClass = meta.touched && meta.error ? "border-red-500" : "";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mb-5 relative">
      <label
        className="block text-[#132145] text-[12px] font-bold mb-2 text-left"
        htmlFor={props.id || props.name}
      >
        {label}
      </label>
      <div className="flex flex-col">
        <div className="absolute border-l mt-1.5 border-gray-400 left-[6vh]"></div>
        {icon === "person" && (
          <IoPersonOutline className="absolute left-0 ml-3 mt-2 items-center text-gray-400" />
        )}
        {icon === "key" && (
          <MdOutlineLock className="absolute left-0 ml-3 mt-2 items-center text-gray-400" />
        )}
        <input
          {...field}
          {...props}
          type={
            props.type === "password"
              ? showPassword
                ? "text"
                : "password"
              : props.type
          }
          className={`pl-[8vh] appearance-none border rounded w-full text-[13px] py-2 px-3 text-gray-700 leading-tight focus:outline-none bg-[#F6FBFF] focus:border-[##2E6243] focus:shadow-[0_0_14px_rgba(0,0,0,0.17)] w-[90%] justify-center ${errorClass}`}
        />

        {props.type === "password" && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-[36px] text-gray-500 focus:outline-none"
          >
            {showPassword ? <FaEye /> : <LuEyeClosed />}
          </button>
        )}
        {meta.touched && meta.error ? (
          <div className="text-red-500 text-xs font-medium text-left mt-2">
            {meta.error}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FromInput;
